import { Route } from 'react-router-dom'

import { DelmanActivatePage } from '@/features/delman/ActivatePage'
import { DelmanEntryRedirect } from '@/features/delman/DelmanEntryRedirect'
import { DelmanLoginPage } from '@/features/delman/LoginPage'
import { DelmanMaterialReturnPage } from '@/features/delman/MaterialReturnPage'
import { DelmanTripDetailPage } from '@/features/delman/TripDetailPage'
import { DelmanTripPage } from '@/features/delman/TripPage'
import { AuthLayout } from '@/shared/layouts/AuthLayout'
import { DelmanAppLayout } from '@/shared/layouts/DelmanAppLayout'

export const delmanRouteElements = (
  <Route path="/delman">
    <Route element={<AuthLayout />}>
      <Route index element={<DelmanEntryRedirect />} />
      <Route path="activate" element={<DelmanActivatePage />} />
      <Route path="login" element={<DelmanLoginPage />} />
    </Route>
    <Route element={<DelmanAppLayout />}>
      <Route path="trip" element={<DelmanTripPage />} />
      <Route path="trip/:tripId" element={<DelmanTripDetailPage />} />
      <Route path="material-return" element={<DelmanMaterialReturnPage />} />
    </Route>
  </Route>
)
